import { CheckoutResultPage } from '@/pages/checkout-product-result';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/checkout-product-result/$sessionId')({
	component: CheckoutResultPage,
});
